export enum DropdownOpenDirection {
  UP,
  DOWN,
}
